(function () {
  var RENTAL_VARIANT_IDS = [48712479146240, 48712483307776];

  function showModal() {
    var modal = /** @type {HTMLElement|null} */ (document.getElementById('contract-modal'));
    if (!modal) return;
    modal.style.display = 'flex';
    document.body.style.overflow = 'hidden';
  }

  function hideModal() {
    var modal = /** @type {HTMLElement|null} */ (document.getElementById('contract-modal'));
    if (!modal) return;
    modal.style.display = 'none';
    document.body.style.overflow = '';
  }

  // Sign button: close the drawer first (it's a native <dialog> in the top layer),
  // then show our modal once the close animation completes.
  document.addEventListener('click', function (e) {
    var target = /** @type {Element} */ (e.target);
    if (!target || !target.closest('.js-sign-contract')) return;
    e.preventDefault();
    var drawer = /** @type {any} */ (document.querySelector('cart-drawer-component'));
    if (drawer) {
      drawer.addEventListener('dialog:close', showModal, { once: true });
      drawer.close();
    } else {
      showModal();
    }
  });

  // Close button inside the modal.
  document.addEventListener('click', function (e) {
    var target = /** @type {Element} */ (e.target);
    if (target && target.closest('#contract-modal-close')) hideModal();
  });

  // Click outside the modal content to close.
  document.addEventListener('click', function (e) {
    var modal = document.getElementById('contract-modal');
    if (e.target === modal) hideModal();
  });

  // Jotform submission postMessage — set cart attribute and reload with drawer open.
  window.addEventListener('message', function (event) {
    if (event.origin && !event.origin.includes('jotform')) return;
    var data = event.data;
    if (typeof data === 'string') {
      try { data = JSON.parse(data); } catch (e) {}
    }
    var submitted =
      data === 'submittedJotForm' ||
      (data && data.action === 'submission-completed') ||
      (typeof event.data === 'string' && event.data.indexOf('submittedJotForm') !== -1);
    if (!submitted) return;
    hideModal();
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { agreement_signed: 'true' } })
    }).then(function () {
      var url = new URL(window.location.href);
      url.searchParams.set('cart_open', '1');
      window.location.href = url.toString();
    });
  });

  // If the cart no longer contains a rental variant but agreement_signed is still
  // set, clear it so the next rental requires signing again.
  fetch('/cart.js')
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      if (cart.attributes.agreement_signed !== 'true') return;
      var hasRental = cart.items.some(function (/** @type {any} */ item) {
        return RENTAL_VARIANT_IDS.indexOf(item.variant_id) !== -1;
      });
      if (hasRental) return;
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { agreement_signed: '' } })
      });
    });

  document.addEventListener('DOMContentLoaded', function () {
    var params = new URLSearchParams(window.location.search);

    // Jotform's thank-you redirect lands here with ?agreement_signed=true.
    // Set the cart attribute then reload so Liquid re-renders with the checkout button.
    if (params.get('agreement_signed') === 'true') {
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { agreement_signed: 'true' } })
      }).then(function () {
        window.location.replace(window.location.pathname);
      });
      return;
    }

    // After the postMessage path sets ?cart_open=1, reopen the drawer.
    if (params.get('cart_open') === '1') {
      var url = new URL(window.location.href);
      url.searchParams.delete('cart_open');
      history.replaceState({}, '', url.toString());
      var drawer = /** @type {any} */ (document.querySelector('cart-drawer-component'));
      if (drawer) drawer.open();
    }
  });
})();
